import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const BIO_IMAGE = "https://customer-assets.emergentagent.com/job_07dd2ee2-42aa-4d8a-a966-79b38cca8e94/artifacts/e1tqbmz2_IMG_2623.png";

export const About = () => {
    return (
        <section
            data-testid="about-section"
            className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 overflow-hidden"
        >
            {/* Smoke background effects */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-1/4 left-0 w-96 h-96 bg-brand-primary/5 rounded-full blur-[100px] animate-pulse" style={{ animationDuration: '4s' }} />
                <div className="absolute bottom-1/4 right-0 w-80 h-80 bg-brand-primary/5 rounded-full blur-[80px] animate-pulse" style={{ animationDuration: '6s', animationDelay: '2s' }} />
            </div>

            <div className="relative max-w-7xl mx-auto">
                <div className="grid md:grid-cols-2 gap-12 items-center">
                    <div className="relative group">
                        {/* Smoke effect behind image */}
                        <div className="absolute -inset-4 bg-gradient-to-t from-brand-primary/20 via-transparent to-transparent blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-1000" />
                        <div className="relative aspect-[4/5] overflow-hidden">
                            <img
                                src={BIO_IMAGE}
                                alt="Faded Keenan"
                                className="w-full h-full object-cover object-top"
                            />
                            {/* Smoke overlay on image */}
                            <div className="absolute inset-0 bg-gradient-to-t from-brand-bg via-transparent to-transparent opacity-60" />
                        </div>
                        <div className="absolute -bottom-6 -right-6 w-24 h-24 border-2 border-brand-primary/30" />
                    </div>
                    <div>
                        <p className="font-mono text-xs text-brand-primary uppercase tracking-widest mb-4">ABOUT</p>
                        <h2 className="font-syne font-bold text-4xl md:text-5xl text-white tracking-tight mb-6">
                            THE ARTIST
                        </h2>
                        <p className="font-space text-slate-300 text-lg leading-relaxed mb-6">
                            Faded Keenan blends the rawness of hip-hop with the soul of neo-soul and the intimacy of indie pop.
                            Based in Texas, his sound is a reflection of late nights, honest conversations, and the spaces in between.
                        </p>
                        <p className="font-space text-slate-400 leading-relaxed mb-8">
                            The StillFaded brand represents more than music—it's a lifestyle, a community,
                            and a movement for those who feel things deeply.
                        </p>
                        <Link to="/music">
                            <Button
                                data-testid="about-explore-btn"
                                variant="outline"
                                className="bg-transparent border border-white/20 text-white hover:bg-white/10 rounded-none px-8 py-4 uppercase tracking-widest"
                            >
                                EXPLORE MUSIC <ArrowRight className="w-4 h-4 ml-2" />
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};
